/**
 * Filter state management for LeadKanban
 */

export type LeadFilters = {
    search: string;
    organisation_name: string;
    email: string;
    phone: string;
    postcode: string;
    estimated_value_min: number | null;
    estimated_value_max: number | null;
    estimated_job_start_from: string | null;
    estimated_job_start_to: string | null;
    estimated_job_end_from: string | null;
    estimated_job_end_to: string | null;
    created_at_from: string | null;
    created_at_to: string | null;
};

export function createDefaultFilters(): LeadFilters {
    return {
        search: '',
        organisation_name: '',
        email: '',
        phone: '',
        postcode: '',
        estimated_value_min: null,
        estimated_value_max: null,
        estimated_job_start_from: null,
        estimated_job_start_to: null,
        estimated_job_end_from: null,
        estimated_job_end_to: null,
        created_at_from: null,
        created_at_to: null,
    };
}

export function hasActiveFilters(filters: LeadFilters): boolean {
    return Object.values(filters).some((v) => v !== '' && v !== null);
}

export function countActiveFilters(filters: LeadFilters): number {
    return Object.values(filters).filter((v) => v !== '' && v !== null).length;
}

export function filtersToApiParams(filters: LeadFilters): Record<string, string | number> {
    const params: Record<string, string | number> = {};

    if (filters.search) params.search = filters.search;
    if (filters.organisation_name) params.organisation_name = filters.organisation_name;
    if (filters.email) params.email = filters.email;
    if (filters.phone) params.phone = filters.phone;
    if (filters.postcode) params.postcode = filters.postcode;
    if (filters.estimated_value_min !== null) params.estimated_value_min = filters.estimated_value_min;
    if (filters.estimated_value_max !== null) params.estimated_value_max = filters.estimated_value_max;
    if (filters.estimated_job_start_from) params.estimated_job_start_from = filters.estimated_job_start_from;
    if (filters.estimated_job_start_to) params.estimated_job_start_to = filters.estimated_job_start_to;
    if (filters.estimated_job_end_from) params.estimated_job_end_from = filters.estimated_job_end_from;
    if (filters.estimated_job_end_to) params.estimated_job_end_to = filters.estimated_job_end_to;
    if (filters.created_at_from) params.created_at_from = filters.created_at_from;
    if (filters.created_at_to) params.created_at_to = filters.created_at_to;

    return params;
}
